// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyB5uDBPRW-bZurrPyNsu4MFC5Vh3NKkK1E",
  authDomain: "apppointage-4d095.firebaseapp.com",
  projectId: "apppointage-4d095",
  storageBucket: "apppointage-4d095.appspot.com",
  messagingSenderId: "719876193462",
  appId: "1:719876193462:web:8d65d9feaa725b9072ba17"
};

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
